import { Flex, Text } from '@fundamentals'
import React from 'react'
import { SystemStyleObject } from '@mui/system'
import { Theme } from '@mui/material'
import { IconButton } from '@common/material'
import Close from '@mui/icons-material/Close'

type GlobalDrawerHeaderProps = {
  title: string
  onClose: () => void
  sx?: SystemStyleObject<Theme>
}

export const GlobalDrawerHeader: React.FC<GlobalDrawerHeaderProps> = ({
  title,
  onClose,
  sx,
}) => {
  return (
    <Flex
      sx={{
        justifyContent: 'space-between',
        alignItems: 'center',
        py: 2,
        mb: 1,
        ...sx,
      }}
    >
      <Text fontSize={18}>{title}</Text>
      <IconButton onClick={onClose}>
        <Close />
      </IconButton>
    </Flex>
  )
}
